import React from 'react';
import { useRemainTimeTextFormat } from '../../../hooks/useRemainTimeTextFormat';
import { Colors, ColorValues, Flex, Typography } from '@banhala/ui-kit';
import {
  convertToDayJs,
  getDayOfWeek,
  isNil,
  isNotNil,
  isTomorrow,
} from 'shared/src/utils';
import { IconBrandIconToday } from '../../IconBrandIconToday';
import { useGetNextWorkingDay } from 'shared/src/hooks';

export const TodayDeliveryRemainTimer: React.FC<{
  remainTime: string | null;
}> = props => {
  const { isTimeOver, text, isOneHourRemaining } = useRemainTimeTextFormat(
    props.remainTime,
  );

  const nextDepartureDay = useGetNextWorkingDay(
    isNotNil(props.remainTime) ? convertToDayJs(props.remainTime) : null,
  );

  if (isTimeOver) {
    if (isNil(nextDepartureDay)) {
      return null;
    }
    const nextDepartureIsTomorrow = isTomorrow(nextDepartureDay);
    return (
      <Flex.Row alignItems={'center'}>
        <Typography type={'body3'} color={'content_secondary'}>
          지금 주문하면{' '}
          <Typography type={'subtitle3'} rawColor={ColorValues.lilac40}>
            {nextDepartureIsTomorrow ? '내일 ' : ''}
            {nextDepartureDay.format('MM/DD')}({getDayOfWeek(nextDepartureDay)})
          </Typography>{' '}
          출발
        </Typography>
      </Flex.Row>
    );
  }

  return (
    <Flex.Row alignItems={'center'}>
      <Typography type={'body3'} color={'content_secondary'}>
        <Typography
          type={'subtitle3'}
          rawColor={
            isOneHourRemaining
              ? Colors.content_pink_primary
              : ColorValues.lilac40
          }
        >
          {text}
        </Typography>{' '}
        내 주문하면
      </Typography>
      <IconBrandIconToday width={45} height={12} />
    </Flex.Row>
  );
};
